import { useConfiguratorStore } from '@store/useConfiguratorStore';
import { Effects } from '@/config/effects';
import { getModelConfig } from '@/config/models';
import './EffectSelector.css';

export default function EffectSelector() {
    const { 
        activeLogoInstanceId, 
        activeTextInstanceId,
        logoInstances, 
        textInstances,
        updateLogoInstance, 
        updateTextInstance,
        glbUrl 
    } = useConfiguratorStore();

    // Determine active instance (Logo or Text)
    const activeLogo = activeLogoInstanceId ? logoInstances.find(li => li.id === activeLogoInstanceId) : null;
    const activeText = activeTextInstanceId ? textInstances.find(ti => ti.id === activeTextInstanceId) : null;
    
    const activeInstance = activeLogo || activeText;

    if (!activeInstance) return null;

    const handleEffectChange = (effectId: string) => {
        if (activeLogo) {
            updateLogoInstance(activeLogo.id, { effect: effectId as any });
        } else if (activeText) {
            updateTextInstance(activeText.id, { effect: effectId as any });
        }
    };

    const modelConfig = getModelConfig(glbUrl || undefined);
    const allowedEffects = modelConfig.allowedEffects;

    return (
        <div className="effect-selector">
            <h4>Print Effect</h4>
            <div className="effect-grid">
                {allowedEffects.map(effectId => {
                    const effect = Effects[effectId];
                    if (!effect) return null;
                    
                    return (
                        <button
                            key={effect.id}
                            className={`effect-option ${activeInstance.effect === effect.id ? 'active' : ''}`}
                            onClick={() => handleEffectChange(effect.id)}
                            title={effect.description}
                        >
                            <span className="effect-name">{effect.label}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
